import type { EventBookings, EventVendorMetadataInput } from '@peles/shared';
import { apiClient } from './client';

/** The event's vendors after the decision — the Vendors view. */
export async function getEventBookings(eventId: string): Promise<EventBookings> {
  const { data } = await apiClient.get<EventBookings>(`/events/${eventId}/bookings`);
  return data;
}

/**
 * Changes some of a booking's details. Only the keys sent are written — merged
 * by the database (`metadataPatch`) — so a stage chosen here never puts back a
 * messaging grant somebody changed a moment ago elsewhere.
 */
export async function patchBooking(linkId: string, patch: EventVendorMetadataInput): Promise<void> {
  await apiClient.patch(`/entity-links/${linkId}`, { metadataPatch: patch });
}
